import { Button, Drawer, Segmented } from 'antd';
import { useUnit } from 'effector-react';
import { useState } from 'react';
import { Column } from '@ant-design/charts';
import parse from 'html-react-parser';
import { CloseOutlined } from '@ant-design/icons';
import {
  $chosenMetric,
  $modalOpen,
  changeModalOpenEv,
} from '../../models/indexCardsModel/index.js';
import style from './SideModal.module.css';
import index_names_dymanics from '../../dictionaries/index_names_dymanics.json';
import { $language } from '../../models/authModel/index.js';
import DescriptionContent from './DescriptionContent.jsx';

export default function SideModal() {
  const open = useUnit($modalOpen);
  const changeModalOpen = useUnit(changeModalOpenEv);
  const chosenMetric = useUnit($chosenMetric);
  const language = useUnit($language);

  const [activeTab, setActiveTab] = useState(0);

  const onClose = () => {
    changeModalOpen(false);
    setActiveTab(0);
  };

  return (
    <Drawer
      title={index_names_dymanics[chosenMetric][`name_${language}`]}
      open={open}
      onClose={onClose}
      closable={false}
      width={600}
      classNames={{
        header: style.modal_header,
        body: style.modal_body,
      }}
    >
      <DescriptionContent activeTab={activeTab} setActiveTab={setActiveTab} />
      <Button
        shape="circle"
        className={[style.close_button, style.close_button_desktop].join(' ')}
        icon={<CloseOutlined />}
        onClick={onClose}
      />
    </Drawer>
  );
}
